import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { BiLinkExternal } from 'react-icons/bi'

import { url } from '../../constants'
import { DetailsPanel, Platforms, UserRatings } from '../../components'
import './GameDetail.css'
import { useAxios } from '../../hooks'

const GameDetail = () => {
  const [gameInfo, setGameInfo] = useState(null);
  const [gameInfo_stores, setGameInfo_stores] = useState();
  let { id } = useParams();
  let gameDataUrl = url.GAMES_API_URL + '/' + id + '?' + url.API_KEY_PARAM
  const { data, error, isLoading } = useAxios(gameDataUrl)
  let storeDataUrl = url.GAMES_API_URL + '/' + id + '/stores?' + url.API_KEY_PARAM
  const storeData = useAxios(storeDataUrl)

  useEffect(() => {
    setGameInfo(data);
  }, [data]);

  useEffect(() => {
    setGameInfo_stores(storeData.data.results);
  }, [storeData.data]);
  function getStoreLink(storeId) {
    return gameInfo_stores.find((item)=> {
      return item.store_id === storeId
    }).url;
  }

  function createHTML(text) {
    return { __html: text}
  }
  
  function toggle(e) {
    let classes = e.target.className
    if(classes.includes('active')) {
      classes = classes.split('active').join('').trim()
    }
    else {
      classes += ' active'
    }
    e.target.className = classes
  }
  return (
    <>
    {isLoading && <p>Loading...</p>}
    {error && <p>{error}</p>}
    {!isLoading && !error && gameInfo &&
      <div className='game__detail'>
        <div className="detail-background">
          <div className='detail-banner' style={{backgroundImage: `url(${gameInfo.background_image})`}}></div>
        </div>
        <div className="detail-info">
          <div className="info-column">
            <div className="detail-box detail-title">
              <h1>{gameInfo.name}</h1>
              <div className="title-undercard">
                <Platforms parent_platforms={gameInfo.parent_platforms} />
              <span>User Rating : {<UserRatings rating={gameInfo.rating} />}</span>  </div>
            </div>
            <div className='accordion' onClick={(e)=>toggle(e)}>About<div className="caret"></div></div>
            <div className="detail-box detail-content" dangerouslySetInnerHTML={createHTML(gameInfo.description)}></div>
            <div className='accordion' onClick={(e)=>toggle(e)}>Details<div className="caret"></div></div>
            <div className="detail-box detail-content"><DetailsPanel gameInfo={gameInfo}/></div>

          </div>
          <div className="info-column">
            <div className="detail-box detail-stores">
              <h3>Buy it here</h3>
              {gameInfo.stores.map(item => {
                return(
                  <div key={item.id} className="link-button" onClick={() => window.open(getStoreLink(item.store.id))}><span>{item.store.name}</span></div>
                )
              })}
            </div>
            <div className="detail-box detail-socials">
              <h3>Socials</h3>
              <div className="socials-links">
                <div className="social">
                  <div className="link-button" onClick={() => window.open(gameInfo.reddit_url)}><span>Reddit  {<BiLinkExternal />}</span></div>
                </div>
                <div className="social">
                  <div className="link-button" onClick={() => window.open(gameInfo.website)}><span>Website  {<BiLinkExternal />}</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    </>
    
  )
}

export default GameDetail